import styled from 'styled-components';
import PageContent from '../../components/PageContent';
import { getAbout } from '../../api/About';
import { useEffect, useState } from 'react';
import { Spin } from 'antd';
import MarkdownIt from "markdown-it";

const mdParser = new MarkdownIt();

const AboutContainer = styled.div`
  /* padding: 20px 0; */
  a {
    color: #fff;
    text-decoration: none;
  }
`;

const AboutTitle = styled.h2`
  font-size: 24px;
  line-height: 38px;
  color: #fff;
`;

const AboutInfo = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  color: #4b555e;
  padding-bottom: 24px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
`;

const AboutContent = styled.div`
  margin-top: 20px;
  font-size: 16px;
  line-height: 1.7;
`;

const About = ({ children }) => {

  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);

  // 数据请求
  const fetchData = async () => {
    setLoading(true);
    try {
      const { data, code } = await getAbout();
      if (code === '10000') {
        setData(data);
      }
      setLoading(false);
    } catch (error) {
      // console.log(error);
      setLoading(false);
    }
  };

  // 初始化数据
  useEffect(() => {
    fetchData();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <PageContent>
      <Spin spinning={loading}>
        <AboutContainer>
          <AboutContent>
            <div dangerouslySetInnerHTML={{__html: mdParser.render(data.content ?? '')}} className='custom-html-style detail-markdown' />

            {/* <ReactMarkdown>{data.content}</ReactMarkdown> */}
          </AboutContent>
        </AboutContainer>
      </Spin>
    </PageContent>
  );
};

export default About;
